import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getOfflineSyncUnavailableReasonDueToPolicy } from "owa-offline-sync-feature-flags/lib/isOfflineSyncAvailable";

export function isPlacesOfflineSyncEnabled(): boolean {
    const shouldCheck = isGlobalFeatureEnabled("msplaces-offline-skip-policy-settings");
    
    // Currently, we are already using IndexedDB storage without the policy settings check,
    // so by default, we should return true to skip the check.
    if (!shouldCheck) {
        return true;
    }
    
    return getOfflineSyncUnavailableReasonDueToPolicy() === undefined;
}
